export const Role = {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/Setting/Role/RolePage.vue'),
    children: [
        {
            path: '/roles/add',
            name: 'roles.add',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/roles/edit/:id',
            name: 'roles.edit',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/roles/delete/:id',
            name: 'roles.delete',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/roles/privileges/edit/:roleId',
            name: 'roles.privileges.edit',
            component: () => import('@/views/Setting/Privilege/PrivilegePage.vue'),
            props: {updateAction: true},
        },
        {
            path: '/roles/privileges/view/:roleId',
            name: 'roles.privileges.view',
            component: () => import('@/views/Setting/Privilege/PrivilegePage.vue'),
            props: {viewAction: true},
        },
    ]
}